import { useContext } from "react";

import {
  AuthProviderContext,
  AuthProviderState,
  AuthenticationStatus,
} from "./context";

// For easier access together with useAuth
export { AuthenticationStatus };

/**
 * See AuthProviderState.
 */
export const useAuth = (): AuthProviderState => {
  const context = useContext(AuthProviderContext);

  return {
    authenticationStatus: context.authenticationStatus,
  };
};
